<p-card class="custom-card">
  <h2 class="section-title mb-6">
    {{ sectionTitle() }}
  </h2>

  <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
    @for (field of fields(); track field.label) {
      <div class="min-w-0" [class]="field.itemClass || ''">
        <app-preview-data-wrapper
          [label]="field.label"
          [labelTooltip]="field.labelTooltip || undefined"
          [data]="field.value"
          [dataType]="field.dataType || PreviewDataType.TEXT"
          [statusSeverity]="field.statusSeverity || null"
          additionalCssClasses="field-label"
          [additionalCssClassesForTextData]="
            field.valueTextClass || 'field-value'
          "
          [additionalCssForDlElement]="'preview-color-silver'"
        ></app-preview-data-wrapper>
      </div>
    }
  </div>
</p-card>
